import Error from './components/error/index.js';
import Warning from './components/warning/index.js';
import FeeDetails from './components/fee-details/index.js';
import FlipButton from './components/flip-button/index.js';
import FromAsset from './components/from-asset/index.js';
import FromAssetInput from './components/from-asset-input/index.js';
import FromAssetValue from './components/from-asset-value/index.js';
import FromAssetLabel from './components/from-asset-label/index.js';
import FromSelect from './components/from-select/index.js';
import FromWalletAccount from './components/from-wallet-account/index.js';
import PercentageSwitch from './components/percentage-switch/index.js';
import ResetButton from './components/reset-button/index.js';
import Root from './components/root/index.js';
import SubmitButton from './components/submit-button/index.js';
import ToAsset from './components/to-asset/index.js';
import ToAssetInput from './components/to-asset-input/index.js';
import ToAssetValue from './components/to-asset-value/index.js';
import ToWalletAccount from './components/to-wallet-account/index.js';
import ToSelect from './components/to-select/index.js';
import ToAssetLabel from './components/to-asset-label/index.js';
const ExchangeForm = Root;
Object.assign(ExchangeForm, {
    Error,
    Warning,
    FeeDetails,
    FlipButton,
    FromAsset,
    FromAssetInput,
    FromAssetValue,
    FromSelect,
    FromWalletAccount,
    PercentageSwitch,
    ResetButton,
    SubmitButton,
    ToAsset,
    ToAssetInput,
    ToAssetValue,
    ToAssetLabel,
    ToSelect,
    ToWalletAccount,
    FromAssetLabel,
});
export * from '../atoms/index.js';
export { MAX_ALLOWED_SPREAD_PERCENTAGE } from './constants.js';
export default ExchangeForm;
